import React, { useEffect } from "react";

export default function Modal({ modal, onClose }) {
  // Tự động focus vào input đầu tiên khi mở modal
  useEffect(() => {
    if (!modal) return;
    const id = setTimeout(() => {
      const f = document.querySelector(".modal-body input, .modal-body select, .modal-body textarea");
      if (f) f.focus();
    }, 120);
    return () => clearTimeout(id);
  }, [modal]);

  return (
    <div
      className={`modal-overlay${modal ? " show" : ""}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      {modal && (
        <div 
          className={`modal${modal.size ? ` modal-${modal.size}` : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-hdr">
            <span className="modal-title">{modal.title}</span>
            <button className="modal-x" onClick={onClose}>
              ✕
            </button>
          </div>
          <div className="modal-body" style={{ color: "var(--text)" }}>
            {modal.content}
          </div>
        </div>
      )}
    </div>
  );
}
